import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { shape, string, bool } from 'prop-types';
// import { Tooltip } from 'antd';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
// import { selectSourceIcon, selectSourceLegend } from '@utils/supportedLanguages';
import SelectionModal from '../SelectionModal/index';
import LanguageIcon from '../LanguageIcon/index';
import { createLanguageFilters } from '@utils/supportedLanguages';
import useDirectoryOrganisations from '@hooks/useDirectoryOrganisations';
import { selectOrganisation } from '@redux/organisations/reducers';
import ActiveIcon from '../ActiveIcon/index';
import { track } from '../../analytics';

function SelectPathwayModal({ defaultFilters, pathways, onSubmit, ...props }) {
  const { t } = useTranslation();
  const getOrgDetailsFromSlug = useDirectoryOrganisations();
  const [, currentOrgData] = useSelector(selectOrganisation());

  useEffect(() => {
    track('Select Pathway Modal open');
  }, []);

  const onTableSubmit = (...args) => {
    track('Select Pathway Modal submit');
    onSubmit(...args);
  };

  const columns = useMemo(
    () => [
      {
        className: 'select-pathway-modal-language-column',
        title: t('common:SelectPathwayModal.columns.language'),
        dataIndex: 'metadata',
        defaultFilteredValue: defaultFilters.language || [],
        key: 'language',
        render: ({ language }) => <LanguageIcon language={language} />,
        filters: createLanguageFilters(t),
        onFilter: (value, record) => record.metadata.language === value,
      },
      // {
      //   title: t('common:SelectPathwayModal.columns.source'),
      //   dataIndex: 'source',
      //   key: 'source',
      //   render: source => (
      //     <Tooltip placement="bottom" title={selectSourceLegend(source, t)}>
      //       <FontAwesomeIcon size="lg" icon={selectSourceIcon(source)} />
      //     </Tooltip>
      //   ),
      //   sorter: (a, b) => a.source.localeCompare(b.source),
      //   filters: [
      //     {
      //       text: t('common:sources.global'),
      //       value: 'global',
      //     },
      //     {
      //       text: t('common:sources.country'),
      //       value: 'country',
      //     },
      //     {
      //       text: t('common:sources.hospital'),
      //       value: 'hospital',
      //     },
      //   ],
      //   onFilter: (value, record) => record.source === value,
      // },
      {
        title: t('common:SelectPathwayModal.columns.name'),
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => a.name.localeCompare(b.name),
      },
      {
        title: t('common:SelectPathwayModal.columns.createdBy'),
        dataIndex: 'parentOrganisationSlug',
        key: 'parentOrganisationSlug',
        render: parentOrganisationSlug => {
          const [, data] = getOrgDetailsFromSlug(parentOrganisationSlug);
          return data?.organisation_name || currentOrgData?.organisation_name;
        },
      },
      {
        className: 'is-active-column',
        title: t('common:SelectPathwayModal.columns.published.title'),
        dataIndex: 'isActive',
        key: 'isActive',
        render: active => <ActiveIcon active={active} />,
        filters: [
          {
            text: t('common:SelectPathwayModal.columns.published.published'),
            value: true,
          },
          {
            text: t('common:SelectPathwayModal.columns.published.unpublished'),
            value: false,
          },
        ],
        onFilter: (value, record) => record.isActive === value,
      },
    ],
    [t, defaultFilters.language, getOrgDetailsFromSlug, currentOrgData],
  );

  const { customTitle } = props;

  return (
    <SelectionModal
      title={customTitle || t('common:SelectPathwayModal.title')}
      dataSource={pathways}
      columns={columns}
      primaryKey="id"
      displayKeys={['name']}
      onSubmit={onTableSubmit}
      {...props}
    />
  );
}

SelectPathwayModal.propTypes = {
  defaultFilters: shape({}),
  customTitle: string,
  addButtontext: string,
  isSelectionOptional: bool,
};

SelectPathwayModal.defaultProps = {
  defaultFilters: {},
  customTitle: undefined,
  addButtontext: undefined,
  isSelectionOptional: false,
};

export default SelectPathwayModal;
